import * as React from "react";
import { Label } from "../Label/Label";
import { FormInputErrorMessage } from "../FormInputErrorMessage/FormInputErrorMessage";
import clsx from "clsx";

type Option = {
  value: string;
  label: string;
};

export interface SelectProps extends React.ComponentProps<"select"> {
  id: string;
  label: string;
  options: Option[];
  errorMessage?: string;
}

function SelectInner(
  props: SelectProps,
  forwardedRef: React.ForwardedRef<HTMLSelectElement>
) {
  const { errorMessage, id, label, options, className, ...rest } = props;

  return (
    <div>
      <Label htmlFor={id}>{label}</Label>

      <select
        {...rest}
        id={id}
        ref={forwardedRef}
        className={clsx(
          "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500",
          className
        )}
        aria-invalid={!!errorMessage}
        aria-describedby={clsx({
          [`${id}-error`]: !!errorMessage,
        })}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>

      <FormInputErrorMessage id={`${id}-error`}>
        {errorMessage}
      </FormInputErrorMessage>
    </div>
  );
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(SelectInner);

Select.displayName = "Select";

export { Select };
